import React, { useState } from "react";

const WHATSAPP_NUMBER = "971545740174";
const WHATSAPP_MESSAGE =
  "Hello GlobalGiftPass! 👋 I need some help. Could you please assist me?";

const WhatsAppButton = () => {
  const [hover, setHover] = useState(false);
  const [showTip, setShowTip] = useState(true);

  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
    WHATSAPP_MESSAGE
  )}`;

  return (
    <div className="ggp-whatsapp-wrap" aria-live="polite">
      {showTip && (
        <div
          className="ggp-whatsapp-tip"
          role="status"
          onClick={() => setShowTip(false)}
        >
          <button
            className="ggp-whatsapp-tip-close"
            onClick={(e) => {
              e.stopPropagation();
              setShowTip(false);
            }}
            aria-label="Close"
          >
            ×
          </button>
          <strong>Need help?</strong>
          <span>Chat with us on WhatsApp — we reply in minutes!</span>
        </div>
      )}

      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className={`ggp-whatsapp-btn ${hover ? "is-hover" : ""}`}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        aria-label="Chat with us on WhatsApp"
        title="Chat with us on WhatsApp"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 32 32"
          width="32"
          height="32"
          aria-hidden="true"
        >
          <path
            fill="#fff"
            d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.506 3.41 4.554 4.34.616.287 2.035.888 2.722.888.817 0 2.15-.33 2.478-1.118.1-.244.143-.487.143-.746 0-.715-1.088-1.147-1.59-1.347-.17-.072-.344-.1-.53-.1z"
          />
          <path
            fill="#fff"
            d="M16.005 0C7.17 0 0 7.17 0 16.005c0 2.826.73 5.595 2.134 8.034L.059 31.114c-.072.3.2.58.5.5l7.31-2.052a15.935 15.935 0 0 0 8.134 2.236c8.834 0 16.003-7.17 16.003-16.004C32.006 7.17 24.838 0 16.005 0zm0 29.14a13.127 13.127 0 0 1-7.138-2.106.57.57 0 0 0-.463-.072l-5.37 1.507 1.517-5.265a.572.572 0 0 0-.086-.505A13.077 13.077 0 0 1 2.866 16.005c0-7.243 5.896-13.14 13.14-13.14 7.244 0 13.14 5.897 13.14 13.14s-5.896 13.135-13.14 13.135z"
          />
        </svg>
      </a>

      <style>{`
        .ggp-whatsapp-wrap {
          position: fixed;
          right: 20px;
          bottom: 20px;
          z-index: 9998;
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          gap: 10px;
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
        }
        .ggp-whatsapp-btn {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          background: #25d366;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 8px 24px rgba(37, 211, 102, 0.45);
          text-decoration: none;
          transition: transform .25s ease, box-shadow .25s ease;
          animation: ggp-wa-pulse 2s infinite;
        }
        .ggp-whatsapp-btn.is-hover,
        .ggp-whatsapp-btn:hover {
          transform: scale(1.08);
          box-shadow: 0 10px 28px rgba(37, 211, 102, 0.6);
        }
        @keyframes ggp-wa-pulse {
          0% { box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.6), 0 8px 24px rgba(37, 211, 102, 0.45); }
          70% { box-shadow: 0 0 0 16px rgba(37, 211, 102, 0), 0 8px 24px rgba(37, 211, 102, 0.45); }
          100% { box-shadow: 0 0 0 0 rgba(37, 211, 102, 0), 0 8px 24px rgba(37, 211, 102, 0.45); }
        }
        .ggp-whatsapp-tip {
          background: #fff;
          color: #111;
          padding: 10px 32px 10px 14px;
          border-radius: 12px;
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
          max-width: 240px;
          position: relative;
          cursor: pointer;
          font-size: 13px;
          line-height: 1.35;
          animation: ggp-wa-slide-in .4s ease;
        }
        .ggp-whatsapp-tip strong {
          display: block;
          font-size: 14px;
          color: #25d366;
          margin-bottom: 2px;
        }
        .ggp-whatsapp-tip-close {
          position: absolute;
          top: 4px;
          right: 8px;
          border: none;
          background: transparent;
          font-size: 18px;
          line-height: 1;
          color: #888;
          cursor: pointer;
          padding: 0;
        }
        .ggp-whatsapp-tip-close:hover { color: #000; }
        @keyframes ggp-wa-slide-in {
          from { opacity: 0; transform: translateY(8px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @media (max-width: 480px) {
          .ggp-whatsapp-wrap { right: 14px; bottom: 14px; }
          .ggp-whatsapp-btn { width: 54px; height: 54px; }
          .ggp-whatsapp-tip { max-width: 200px; font-size: 12px; }
        }
      `}</style>
    </div>
  );
};

export default WhatsAppButton;
